<template>
  <NewBsBox
    class="alert-wrapper"
    :bs="wrapperBs"
  >
    <div class="title-container">
      <NewBsBox
        v-if="showIcon"
        class="title-icon"
        :bs="{ mr: 9,}"
      >
        <slot name="icon">
          <BeerIcon
            v-if="icon"
            :size="14"
            :bs="{
              mt: 4,
              flex: '0 0 14px'
            }"
            :color="null"
            :icon-path="icon"
            data-icon="type"
          />
        </slot>
      </NewBsBox>
      <div class="alert-title">
        <slot>
          {{ title }}
        </slot>
      </div>
    </div>
    <div class="content-container">
      <slot name="action" />
      <BeerText
        v-if="clickDetail"
        class="content-detail"
        :bs="{ lineHeight: 1, mt: 3 }"
        variant="link"
        @click="clickDetail"
      >{{ detailText }}</BeerText>
      <NewBsBox
        :bs="{
          ml: 16,
          cursor: 'pointer',
          fontSize: 14,
          color: 'mute',
        }"
        class="content-close"
      >
        <slot name="close">
          <BeerIcon
            v-if="clickDismiss"
            :bs="{ mt: 4 }"
            :size="16"
            :grid-size="16"
            :color="null"
            :icon-path="$options.CROSS_PATH_16"
            aria-label="close"
            data-icon="cross"
            @click="dismiss"
          />
        </slot>
      </NewBsBox>
    </div>
  </NewBsBox>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import BeerText from '@xhs/yam-beer/cmp/common/Text/Text.vue'
  import { CROSS_PATH_16 } from '@xhs/yam-beer/cmp/constants/builtinIcon'
  import { BeerStyleObj } from '../../../core'

  import getIcon from './getIcon'
  import initStyle from './style'

  initStyle()

  export default defineComponent({
    name: 'BeerAlert',
    components: {
      BeerIcon,
      NewBsBox,
      BeerText,
    },
    props: {
      /**
       * 容器 inline 样式
       * @ignore
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       */
      titleBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * alert 内容
       */
      title: String,
      /**
       * 意图颜色，用来呈现不同的的意图提示
       *
       * @type {info|success|warn|error}
       */
      modifier: {
        type: String as PropType<string>,
        default: 'info',
        validator(val: string) {
          return ['success', 'warn', 'error', 'info'].includes(val)
        },
      },
      /**
       * alert 的类型，inline 放在内容块，global 放在全局浮层上
       * @type {inline|global}
       */
      variant: {
        type: String as PropType<string>,
        default: 'inline',
        validator(val: string) {
          return ['inline', 'global'].includes(val)
        },
      },
      /**
       * 查看详情文本
       */
      detailText: {
        type: String,
        default: '查看详情',
      },
      /**
       * 点击关闭图标函数
       */
      clickDismiss: {
        type: Function,
        required: false,
      },
      /**
       * 点击查看详情
       */
      clickDetail: {
        type: Function,
        required: false,
      },
      /**
       * 是否显示图标
       */
      showIcon: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      icon(): string[]|undefined {
        if (!this.showIcon) {
          return undefined
        }
        return getIcon(this.modifier)
      },
      width(): number {
        if (this.variant === 'global') {
          return this.clickDetail ? 360 : 290
        }
        return this.clickDetail ? 600 : 400
      },
      wrapperBs(): BeerStyleObj {
        return {
          width: this.width,
          'cmp.alert.base': 'wrapper',
          '.title-container': {
            display: 'flex', alignItems: 'flex-start',
          },
          '.alert-title': {
            'cmp.alert.base': `${this.variant}Title`,
            ...this.titleBs,
          },
          '.content-container': {
            display: 'flex', alignItems: 'center', alignSelf: 'flex-start',
          },
          ...this.bs,
        }
      },
    },
    methods: {
      dismiss(e: Event) {
        if (this.clickDismiss) {
          this.clickDismiss(e)
        }
      },
    },
    CROSS_PATH_16,
  })
</script>
